import {
  FETCH_AUDIT_TRAIL_FAILURE,
  FETCH_AUDIT_TRAIL_REQUEST,
  FETCH_AUDIT_TRAIL_SUCCESS,
  FETCH_RECENT_ACTIVITIES_FAILURE,
  FETCH_RECENT_ACTIVITIES_REQUEST,
  FETCH_RECENT_ACTIVITIES_SUCCESS,
} from '../reducers/types';
import {
  getActivitiesService,
  getAuditTrailService,
} from '../services/ActivityService';

export const getActivitiesAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_RECENT_ACTIVITIES_REQUEST,
      });
      const response = await dispatch(getActivitiesService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_RECENT_ACTIVITIES_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_RECENT_ACTIVITIES_FAILURE,
          payload: response.data.message,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_RECENT_ACTIVITIES_FAILURE,
      });
    }
  };
};

export const getAuditTrailAction = params => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_AUDIT_TRAIL_REQUEST,
      });
      const response = await dispatch(getAuditTrailService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_AUDIT_TRAIL_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_AUDIT_TRAIL_FAILURE,
          payload: response.data.message,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_AUDIT_TRAIL_FAILURE,
      });
    }
  };
};
